import { Link } from 'react-router-dom';
import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';

const features = [
  {
    title: 'AI Medical Scribe',
    description: 'SOAP notes, referral letters, and discharge summaries generated automatically from consultations.',
    icon: '🩺',
  },
  {
    title: 'Operations AI',
    description: 'Scheduling, bed management, pharmacy, and supply chain — all in one dashboard.',
    icon: '🏥',
  },
  {
    title: 'Built for Africa',
    description: 'Offline-capable. On-premise deployable. Works in English, Hausa, Twi, and Pidgin.',
    icon: '🌍',
  },
];

export default function MarketingHome() {
  return (
    <div className="bg-[#F0F9FF] min-h-screen flex flex-col">
      <MarketingNav />

      {/* Hero */}
      <section className="bg-[#0A2540] text-white py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            Doctors shouldn't spend half their day on paperwork.
          </h1>
          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
            Scrivera listens to your consultations and writes the notes. So your doctors can focus on patients.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-[#06B6D4] text-white font-semibold px-8 py-3 rounded-lg hover:bg-[#0E7490] transition-colors"
            >
              Request Early Access
            </Link>
            <a
              href="#features"
              className="border border-slate-400 text-white font-semibold px-8 py-3 rounded-lg hover:border-white transition-colors"
            >
              See how it works
            </a>
          </div>
        </div>
      </section>

      {/* Features strip */}
      <section id="features" className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-bold text-[#0A2540] text-center mb-12">
            Everything your facility needs, in one platform
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {features.map((f) => (
              <div key={f.title} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100">
                <div className="text-4xl mb-4">{f.icon}</div>
                <h3 className="text-lg font-semibold text-[#0A2540] mb-2">{f.title}</h3>
                <p className="text-[#64748B] text-sm leading-relaxed">{f.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust strip */}
      <section className="bg-white border-y border-slate-200 py-8 px-6">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-[#64748B] text-center">
          <span>Incubated by <strong className="text-[#0A2540]">Darrel Technologies Ltd</strong></span>
          <span className="hidden md:block text-slate-300">·</span>
          <span>Designed for West African healthcare realities</span>
          <span className="hidden md:block text-slate-300">·</span>
          <span>Offline-capable · On-premise · Multilingual</span>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-[#0E7490] text-white py-20 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to give your clinicians their time back?</h2>
          <p className="text-lg text-teal-100 mb-8">
            Join our Early Access Programme. Limited slots available.
          </p>
          <Link
            to="/contact"
            className="bg-white text-[#0E7490] font-semibold px-8 py-3 rounded-lg hover:bg-[#F0F9FF] transition-colors"
          >
            Apply for Early Access
          </Link>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
